import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["serverSelect", "partySizeButton"]

  addServer(event) {
    const serverSelect = this.serverSelectTarget
    if (serverSelect && serverSelect.value) {
      const link = event.currentTarget
      const url = new URL(link.href)
      url.searchParams.set("sitting[server_id]", serverSelect.value)
      link.href = url.toString()
    }
  }
}
